import { useState } from 'react';

import { Card } from '../../components/ui/Card';

interface SyncLineCardProps {
  /** Devolve a mensagem de resultado; a tela mostra no toast. */
  onSync: (line: string) => Promise<void>;
}

/**
 * Sincroniza uma linha avulsa, sem passar pela listagem.
 *
 * Existe aqui, no meio dos serviços assíncronos, porque a pergunta é a mesma:
 * "roda isso agora para mim". Quem chega com o número na mão — a linha que está
 * migrando de conta, a que o cliente acabou de reclamar — não quer paginar até
 * achá-la na tela de Linhas.
 */
export function SyncLineCard({ onSync }: SyncLineCardProps) {
  const [line, setLine] = useState('');
  const [syncing, setSyncing] = useState(false);

  const submit = async () => {
    if (!line.trim() || syncing) return;

    setSyncing(true);

    try {
      await onSync(line.trim());
      setLine('');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Card>
      <div className="text-[14px] font-extrabold">Sincronizar uma linha específica</div>
      <div className="text-ink-600 mt-0.5 text-[12px]">
        Útil quando a linha está migrando entre contas — sincroniza apenas o número informado.
      </div>

      <form
        className="mt-3 flex flex-wrap gap-2"
        onSubmit={(event) => {
          event.preventDefault();
          void submit();
        }}
      >
        <input
          value={line}
          onChange={(event) => setLine(event.target.value)}
          placeholder="(62) 9xxxx-xxxx"
          inputMode="tel"
          aria-label="Número da linha"
          className="border-line-300 focus:border-navy-800 min-w-[180px] flex-1 rounded-[10px] border px-3 py-2.5 text-[14px] outline-none"
        />

        <button
          type="submit"
          disabled={!line.trim() || syncing}
          className="bg-navy-800 hover:bg-navy-950 rounded-[10px] px-[18px] py-2.5 text-[13px] font-extrabold text-white disabled:opacity-50"
        >
          {syncing ? 'Sincronizando…' : 'Sincronizar'}
        </button>
      </form>
    </Card>
  );
}
